__turbopack_context__.v({
  "_destructive": "nNmfKG__destructive",
  "_large": "nNmfKG__large",
  "_medium": "nNmfKG__medium",
  "_primary": "nNmfKG__primary",
  "_secondary": "nNmfKG__secondary",
  "_small": "nNmfKG__small",
  "_wide": "nNmfKG__wide",
  "button": "nNmfKG_button",
  "circle": "nNmfKG_circle",
  "content": "nNmfKG_content",
  "loading": "nNmfKG_loading",
  "rotate": "nNmfKG_rotate",
});
